var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLitentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.211 40.5674H96.7499C96.7284 41.1535 96.8688 41.7341 97.1555 42.245C97.4421 42.7559 97.8638 43.1772 98.374 43.4621C98.8841 43.7471 99.4628 43.8847 100.046 43.8596C100.629 43.8345 101.184 43.677 101.694 43.4218C102.204 43.1666 102.656 42.4601 102.976 41.6458C103.84 41.6458 104.756 41.6458 105.914 41.6458C105.01 45.4911 101.974 47.1655 98.2749 46.4702C97.395 46.2842 96.5617 45.9208 95.8255 45.402C95.0892 44.8833 94.4654 44.2198 93.9915 43.4519C93.5177 42.684 93.2037 41.8274 93.0686 40.9341C92.9336 40.0408 92.9801 39.1292 93.2056 38.2545C93.3711 37.3813 93.7073 36.5497 94.1947 35.8078C94.682 35.066 95.3109 34.4285 96.0449 33.9324C96.7789 33.4363 97.6035 33.0913 98.471 32.9174C99.3385 32.7435 100.232 32.7441 101.099 32.9192C104.629 33.43 106.747 36.4524 106.211 40.5674ZM96.5804 38.2545H102.921C102.91 37.8948 102.828 37.5409 102.679 37.2134C102.531 36.8859 102.319 36.5913 102.056 36.347C101.793 36.1026 101.485 35.9133 101.148 35.7901C100.812 35.6669 100.454 35.6123 100.096 35.6294C99.2865 35.5264 98.4684 35.7421 97.8131 36.2314C97.1578 36.7206 96.7161 37.4455 96.5804 38.2545Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.166 46.2151H118.848V39.1204C118.848 37.3041 118.339 35.8142 116.193 35.6581C115.737 35.6209 115.278 35.6845 114.849 35.8445C114.42 36.0046 114.031 36.2571 113.709 36.5844C113.387 36.9116 113.141 37.3057 112.987 37.739C112.833 38.1722 112.776 38.634 112.818 39.092C112.719 41.3907 112.818 43.7036 112.818 46.1868H109.472V33.4162C110.884 33.2885 112.663 33.0701 112.663 34.9486C113.206 34.465 113.782 34.0194 114.386 33.6148C115.11 33.1405 115.945 32.8631 116.808 32.8099C117.671 32.7566 118.533 32.9293 119.31 33.3111C120.087 33.6928 120.752 34.2706 121.24 34.9879C121.729 35.7052 122.023 36.5375 122.096 37.4034C122.273 40.3374 122.297 43.2787 122.166 46.2151Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.976 33.2044C147.66 33.173 149.139 33.1634 149.139 33.1634C149.139 33.1634 149.78 34.4457 150.421 35.728C151.062 37.0103 152.356 39.7872 153.387 42.3555C154.46 39.8155 155.57 36.8977 156.191 35.728C156.812 34.5582 157.474 33.1634 157.474 33.1634C157.474 33.1634 159.718 33.1634 161 33.2042L159.431 36.4384C157.496 40.823 155.449 45.1508 153.698 49.6063C153.35 50.5002 152.665 51.7568 152.665 51.7568C152.665 51.7568 150.93 51.8172 149.459 51.7568C149.618 51.5376 149.681 51.2859 149.78 51.1156C152.344 45.6658 152.024 45.6658 152.024 45.6658C152.024 45.6658 150.274 42.6415 149.335 40.8939C148.156 38.49 146.905 35.7163 145.976 33.2044Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3851 43.6324H72.4339L72.6033 46.1723H61.1797V27.882H64.3851V43.6324Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3737 31.2025L45.8589 33.5296C44.3934 35.248 42.8429 36.8913 41.2132 38.4534C40.838 38.7243 40.4101 38.9124 39.9574 39.0053C39.5048 39.0982 39.0377 39.0939 38.5868 38.9926C37.9061 38.7908 37.1799 38.8051 36.5076 39.0337C35.8353 39.2623 35.2496 39.6939 34.8307 40.2696C32.1478 43.2778 29.3942 46.215 26.5701 49.28L24.0566 47.0664C26.6972 44.2285 29.2107 41.3906 31.8654 38.7372C32.551 38.2934 33.3817 38.1356 34.1811 38.2973C34.9924 38.4232 35.8224 38.3262 36.5831 38.0164C37.3439 37.7066 38.007 37.1957 38.5021 36.5378C40.013 34.7499 41.6227 33.1039 43.3737 31.2025Z",
    fill: "url(#paint0_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1191 54.4023L29.6621 52.1462C33.0652 48.4286 36.3129 44.8244 39.6454 41.2912C39.893 41.0223 40.195 40.8098 40.5311 40.6678C40.8672 40.5259 41.2296 40.4578 41.5941 40.4682C44.4182 41.0642 46.1691 39.6736 47.7083 37.6303C48.019 37.2188 48.3861 36.8499 48.8944 36.2965L51.2949 38.4959C49.9817 40.4682 48.7673 42.0575 45.9997 41.1777C45.2513 40.9365 43.8816 41.7453 43.1756 42.4548C39.9419 45.7893 36.8636 49.2516 33.7147 52.6712C33.2205 53.253 32.7122 53.778 32.1191 54.4023Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3864 39.0917L13 36.9207C14.4121 34.7497 15.9371 33.3591 18.733 33.728C19.3457 33.6809 19.9431 33.5125 20.4908 33.2324C21.0385 32.9524 21.5257 32.5662 21.9243 32.0962C25.3556 28.5488 28.6457 24.8454 32.1617 21L34.7317 23.2703C31.3286 26.9738 28.0244 30.6205 24.6354 34.1679C24.3528 34.3986 24.0211 34.5609 23.666 34.6421C23.311 34.7233 22.9421 34.7212 22.5879 34.6361C21.7357 34.3267 20.8025 34.3277 19.9509 34.6388C19.0993 34.95 18.3835 35.5517 17.9281 36.3389C17.1797 37.2754 16.3748 38.0984 15.3864 39.0917Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8242 33.2596C82.2754 33.2685 82.6675 33.2713 82.9881 33.2712C83.5279 33.2709 83.9564 32.8315 83.9564 32.2917C83.9564 31.6092 83.9564 30.6679 83.9564 29.8116H87.3595V33.2596L90.692 33.3164V35.7996H87.3595C87.3595 37.9719 87.3471 40.9154 87.4866 42.0571C87.6261 43.1989 88.5502 43.4216 90.1936 43.5187H90.6355V46.0586C85.9192 47.0235 83.9847 45.491 83.9564 40.7659V35.7996H81.8242V33.2596Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.454 32.7645C124.905 32.7734 125.297 32.7762 125.618 32.7761C126.158 32.7758 126.586 32.3364 126.586 31.7966C126.586 31.1141 126.586 30.1727 126.586 29.3165H129.989V32.7645L133.322 32.8213V35.3044H129.989C129.989 37.4767 129.977 40.4203 130.116 41.562C130.256 42.7038 131.18 42.9265 132.823 43.0236H133.265V45.5635C128.549 46.5284 126.615 44.9959 126.586 40.2708V35.3044H124.454V32.7645Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9638 44.2286L18.5068 41.9299C20.2296 40.0711 21.8393 38.2122 23.5903 36.5237C24.195 36.1017 24.9398 35.9337 25.666 36.0554C26.5815 36.1941 27.5174 36.0752 28.3698 35.7121C29.2222 35.3489 29.9579 34.7556 30.4953 33.9979C32.6981 31.4438 35.0421 29.0174 37.3297 26.5342C37.496 26.4136 37.6761 26.3136 37.8662 26.2363L40.2244 28.4215C37.7392 31.1175 35.4375 33.7567 32.9381 36.2257C32.5612 36.4986 32.1308 36.6878 31.6756 36.7807C31.2203 36.8737 30.7506 36.8683 30.2976 36.7649C29.6177 36.5614 28.8916 36.5764 28.2207 36.8079C27.5497 37.0394 26.9676 37.4759 26.5556 38.0561C24.847 40.0852 22.9831 42.0292 20.9638 44.2286Z",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.128 46.2576H136.895V33.3167C138.307 33.3167 140.001 33.1634 140.001 34.835L144.76 32.4512V36.183C144.294 36.2682 143.8 36.3959 143.348 36.4526C142.914 36.4476 142.484 36.533 142.085 36.7036C141.685 36.8741 141.326 37.1261 141.029 37.4435C140.731 37.761 140.503 38.1369 140.357 38.5477C140.212 38.9584 140.153 39.395 140.185 39.8297C140.086 41.9014 140.128 43.9873 140.128 46.2576Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9858 33.345V46.1155H75.8086V33.345H78.9858Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.3297,
    cy: 29.3166,
    r: 1.92345,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 43.8907,
    y1: 32.145,
    x2: 24.9763,
    y2: 47.5952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35547,
    stopColor: "#1FC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434356,
    stopColor: "#09D572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FEB87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49.3421,
    y1: 37.2405,
    x2: 30.4341,
    y2: 52.5413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205153,
    stopColor: "#1FC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313372,
    stopColor: "#09D572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AE386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.7699,
    y1: 21.9433,
    x2: 13.8559,
    y2: 37.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586425,
    stopColor: "#1FC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696136,
    stopColor: "#09D572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D572"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.2639,
    y1: 27.1743,
    x2: 19.4354,
    y2: 42.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396173,
    stopColor: "#1FC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487382,
    stopColor: "#09D572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06DD75"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitentry);
export default __webpack_public_path__ + "static/media/litentry.86942e8afb436a30b3a944b782f93a6c.svg";
export { ForwardRef as ReactComponent };